"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectItemV2 = void 0;

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _styles = require("./styles");

var _utils = require("../../../global-files/utils");

var _freeSolidSvgIcons = require("@fortawesome/free-solid-svg-icons");

var _jsxRuntime = require("react/jsx-runtime");

var SelectItemV2 = function SelectItemV2(props) {
  var id = props.id,
      keyId = props.keyId,
      className = props.className,
      label = props.label,
      value = props.value,
      checkbox = props.checkbox,
      selected = props.selected,
      _onClick = props.onClick;
  return checkbox ? /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    className: "selectItemV2" + ((0, _utils.isStringEmpty)(className) ? "" : " " + className) + (!checkbox && selected ? " selectedItem" : ""),
    id: id,
    checkbox: checkbox,
    onClick: function onClick(event) {
      return _onClick && _onClick(!selected, value);
    },
    children: [checkbox !== undefined && /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Checkbox, {
      className: "checkbox" + (checkbox ? "" : " hidden"),
      checked: selected
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
      className: "label",
      children: label
    })]
  }, keyId) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ContainerButton, {
    className: "selectItemV2" + ((0, _utils.isStringEmpty)(className) ? "" : " " + className) + (selected ? " selectedItem" : ""),
    checkbox: checkbox === false,
    type: "whiteS3",
    label: label,
    icon: checkbox === false || selected ? _freeSolidSvgIcons.faCheck : undefined,
    onClick: function onClick(event) {
      _onClick && _onClick(!selected, value);
    }
  });
};

exports.SelectItemV2 = SelectItemV2;